import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userService = environment.userService + '/v1';
  private refreshTokenUrl = `${this.userService}/user/get-access-token`;

  constructor(private http: HttpClient) {}

  refreshToken(): Observable<{ token: string, tokenExpiresAt: string, userId: string }> {
    const refreshToken = this.getItemFromStorage('refreshToken');
    const userId = this.getItemFromStorage('user-id');
  
    const body = {
      refreshToken: refreshToken || '',
      userId: userId || ''
    };
  
    return this.http.post<{ token: string, tokenExpiresAt: string }>(this.refreshTokenUrl, body)
      .pipe(
        map(response => ({
          userId: body.userId,
          token: response.token,
          tokenExpiresAt: response.tokenExpiresAt
        }))
      );
  }

  private getItemFromStorage(key: string): string | null {
    const item = localStorage.getItem(key);
    if (item) {
      try {
        return JSON.parse(item);
      } catch {
        return item;
      }
    }
    return null;
  }
}